<div class="fishyops-page">
  <div class="page-header">
    <div class="title-group">
      <span class="bot-avatar"><img src="assets/images/fishyops-kraken.png" alt="" /></span>
      <div>
        <h1>FishyOps AI</h1>
        <p class="muted">
          Orders, customers, vendors, products — read-only, nothing saved once you leave.
        </p>
      </div>
    </div>
    <button mat-stroked-button (click)="clear()" [disabled]="!messages().length">
      <mat-icon inline>refresh</mat-icon> New session
    </button>
  </div>

  <div class="chat-window">
    @if (!messages().length) {
      <div class="empty-state">
        <span class="bot-avatar large"><img src="assets/images/fishyops-kraken.png" alt="" /></span>
        <p>Ask me about an order, a customer, or which vendor carries a fish.</p>
        <div class="examples">
          @for (q of examples; track q) {
            <button mat-stroked-button (click)="useExample(q)">{{ q }}</button>
          }
        </div>
      </div>
    }

    @for (m of messages(); track $index) {
      <div class="bubble-row" [class.user]="m.role === 'user'">
        @if (m.role === 'assistant') {
          <span class="avatar"><img src="assets/images/fishyops-kraken.png" alt="" /></span>
        }
        <div class="bubble-stack">
          <div class="bubble" [class.user]="m.role === 'user'">
            <div class="bubble-text">{{ m.content }}</div>
          </div>

          @for (v of m.views; track $index) {
            @if (v.kind === 'order') {
              <div class="data-card order-card">
                <div class="order-header">
                  <span class="order-id">Order #{{ v.order.id }}</span>
                  <span class="pill">{{ v.order.order_status }}</span>
                  <span class="pill muted-pill">{{ v.order.payment_status }}</span>
                </div>
                <div class="order-meta">
                  <span>{{ v.order.first_name }} {{ v.order.last_name }} · {{ v.order.customer_email }}</span>
                  <span class="muted">{{ v.order.created_on | date: 'medium' }}</span>
                </div>
                @if (v.items.length) {
                  <div class="table-wrap">
                    <table class="data-table">
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>Vendor</th>
                          <th>Qty</th>
                          <th>Price</th>
                          <th>Delivery status</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (it of v.items; track $index) {
                          <tr>
                            <td>{{ it.product_name }}{{ it.addon_name ? ' (' + it.addon_name + ')' : '' }}</td>
                            <td>{{ it.vendor_name }}</td>
                            <td>{{ it.quantity }}</td>
                            <td>{{ it.final_price ?? it.price }}</td>
                            <td>
                              <span class="pill status-pill">{{ it.delivery_status }}</span>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
                @if (v.note) {
                  <p class="data-note">{{ v.note }}</p>
                }
              </div>
            }
            @if (v.kind === 'tables') {
              @for (t of v.tables; track t.title) {
                <div class="data-card">
                  <div class="data-card-header">
                    <span class="data-card-title">{{ t.title }}</span>
                    <span class="muted">{{ rowCount(t) }}</span>
                  </div>
                  <div class="table-wrap">
                    <table class="data-table">
                      <thead>
                        <tr>
                          @for (c of t.columns; track c) {
                            <th>{{ c }}</th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        @for (row of t.rows; track $index) {
                          <tr>
                            @for (c of t.columns; track c) {
                              <td>{{ cell(row, c) }}</td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              }
            }
          }

          @if (m.toolCalls?.length) {
            <button class="trace-toggle" mat-button (click)="toggleTrace(m)">
              <mat-icon inline>{{ m.showTrace ? 'expand_less' : 'expand_more' }}</mat-icon>
              {{ m.toolCalls?.length }} lookup{{ m.toolCalls?.length === 1 ? '' : 's' }}
            </button>
            @if (m.showTrace) {
              <div class="trace">
                @for (t of m.toolCalls; track $index) {
                  <div class="trace-item">
                    <div class="trace-name">{{ t.name }}({{ t.arguments | json }})</div>
                    @if (t.error) {
                      <div class="trace-error">{{ t.error }}</div>
                    }
                  </div>
                }
              </div>
            }
          }
        </div>

        @if (m.role === 'assistant') {
          <button
            class="copy-btn"
            mat-icon-button
            matTooltip="Copy reply"
            (click)="copy(m.content, $index)"
          >
            <mat-icon inline>{{ copiedIndex() === $index ? 'check' : 'content_copy' }}</mat-icon>
          </button>
        }
      </div>
    }

    @if (sending()) {
      <div class="bubble-row">
        <span class="avatar"><img src="assets/images/fishyops-kraken.png" alt="" /></span>
        <div class="bubble pending">
          <mat-spinner diameter="16"></mat-spinner>
          Looking that up…
        </div>
      </div>
    }

    @if (error()) {
      <p class="error">{{ error() }}</p>
    }

    <div #scrollAnchor></div>
  </div>

  <div class="composer">
    <textarea
      #composerInput
      [(ngModel)]="draft"
      (keydown)="onKeydown($event)"
      placeholder="Ask FishyOps AI…"
      rows="1"
    ></textarea>
    <button mat-fab color="primary" extended (click)="send()" [disabled]="sending() || !draft.trim()">
      <mat-icon>send</mat-icon>
    </button>
  </div>
</div>
